/**
 * Type of cards containing graphics and data
 */
export enum CardType {
    PRODUCTION = 'PRODUCTION',
    CONSUMPTION = 'CONSUMPTION',
    SUMMARY = 'SUMMARY',
    AUTOCONSUMPTION = 'AUTOCONSUMPTION',
    SELF_RELIANCE = 'SELF_RELIANCE',
    STORAGE = 'STORAGE',
    SUNOLOGY_PRICE_EVOLUTION = 'SUNOLOGY_PRICE_EVOLUTION',
    ENERGY_SOURCES_DISTRIBUTION = 'ENERGY_SOURCES_DISTRIBUTION',
}
